<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <!-- Header -->
    <layout-header />
    <!-- /Header -->

    <!-- Breadcrumb -->
    <!-- /Breadcrumb -->

    <!-- Page Content -->
    <div class="content success-page-cont">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <!-- Success Card -->
            <div class="card success-card">
              <div class="card-body">
                <div class="success-cont">
                  <i class="fas fa-check"></i>
                  <h3>Réservation Confirmée!</h3>
                  <h4>Merci pour votre réservation! Votre paiement a été traité avec succès.</h4>
                  <p>
                    Match réservé par <strong>{{ currentUser.first_name }} {{ currentUser.last_name }}</strong><br/>
                    Le <strong>{{ formatDate(booking.created_at) }} à {{ formatDate(booking.created_at, 'HH:mm') }}</strong>
                  </p>

                  <div class="avatar avatar-lg border-sm">
                    <img class="avatar-img" :src="'/api/static/' + booking.slot.field.stadium.stadium_logo + '.jpg'" alt="Stadium Logo">
                  </div>
                  <h5 class="text-primary mt-1 mb-0"><b>{{ booking.slot.field.stadium.business_name }}</b></h5>
                  <h5 class="mb-2">{{ booking.slot.field.name }}</h5>
                  <p class="mb-1">
                    <span class="fas fa-map-marker-alt text-primary mr-1"></span> {{ booking.slot.field.stadium.state }}, TN
                  </p>
                  <p class="mb-1">
                    <span class="far fa-calendar-alt text-primary mr-1"></span> {{ formatDate(booking.start_time) }}
                  </p>
                  <p class="mb-4">
                    <span class="far fa-clock text-primary mr-1"></span> {{ formatDate(booking.start_time, 'HH:mm') }} - {{ formatDate(booking.end_time, 'HH:mm') }}
                  </p>
                </div>
              </div>
            </div>
            <!-- /Success Card -->
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Footer -->
    <layout-footer />
    <!-- /Footer -->
  </div>
</template>
<script>
import { api } from "@/store";
export default {
  props: ['id'],
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
  },
  data() {
    return {
      booking: {},
    }
  },
  created() {
    this.getBooking()
  },
  methods: {
    async getBooking() {
      return await api.get('/my/bookings/' + this.id)
        .then(response => {
          const result = response.data
          this.booking = result
          if (this.booking.status != 'confirmed') 
            window.location.replace("/booking/" + this.id + '/failure')
        })
    },
    formatDate(date, format = 'LL') {
      if (date) {
        date.replace('T', ' ').replace('.000000Z', '')
        return moment(String(date)).format(format)
      }
    },
  },
};
</script>
